import { z } from 'zod'

/** ฟอนต์จากชุดที่ระบบโฮสต์เอง — ไม่โหลดจากอินเทอร์เน็ต ทำให้เรนเดอร์เหมือนกันทุกเครื่อง */
export const FONT_IDS = ['system', 'sarabun', 'noto-sans-thai', 'prompt'] as const
export type FontId = (typeof FONT_IDS)[number]

export const ThemeSchema = z.strictObject({
  primaryColor: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'สีต้องอยู่ในรูปแบบ #RRGGBB')
    .default('#d81f26'),
  fontId: z.enum(FONT_IDS).default('system'),
  brandText: z.string().max(60).default('AYI Plus'),
  brandSubtext: z.string().max(120).default(''),
  /** ถ้ามีโลโก้ จะแสดงแทน brandText */
  logoAssetId: z.string().nullable().default(null),
  /** สีพื้นหลังทั้งหน้าของเว็บแอปที่พนักงานเห็น — ไม่ตั้ง (null) = ใช้พื้นหลังสีขาวมาตรฐาน */
  backgroundColor: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'สีต้องอยู่ในรูปแบบ #RRGGBB')
    .nullable()
    .default(null),
  /**
   * สีของแถบความคืบหน้า — ไม่ตั้ง (null) = ใช้สีหลัก
   * แยกออกมาต่างหากเพราะถ้าตั้งพื้นหลังเป็นสีเดียวกับสีหลัก แถบจะกลืนไปกับพื้นจนมองไม่เห็น
   */
  progressColor: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'สีต้องอยู่ในรูปแบบ #RRGGBB')
    .nullable()
    .default(null),
})

export type Theme = z.infer<typeof ThemeSchema>

export const DEFAULT_THEME: Theme = ThemeSchema.parse({})
